import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-kondgruppe-list-view',
  imports: [],
  templateUrl: './kondgruppe.list-view.html',
  styleUrls: ['./kondgruppe.list-view.css'],
})
export class KondgruppeListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
